// Copyright ©️ 2026 eVolve MEP, LLC

/** Converts a 0-based index to letters: 0 → A, 25 → Z, 26 → AA. */
const indexToLetters = (index: number): string => {
  let remaining = index;
  let letters = '';
  do {
    letters = String.fromCharCode(65 + (remaining % 26)) + letters;
    remaining = Math.floor(remaining / 26) - 1;
  } while (remaining >= 0);
  return letters;
};

/**
 * Returns the first name of the form `<base> A`, `<base> B`, … that is not in `takenNames`.
 * @param base The name before the letter, such as a bend type name.
 * @param takenNames Names already in use, such as the names of the bends in the bend list.
 */
export const getFreeName = (base: string, takenNames: readonly string[]): string => {
  const taken = new Set(takenNames);
  for (let index = 0; ; index++) {
    const candidate = `${base} ${indexToLetters(index)}`;
    if (!taken.has(candidate)) return candidate;
  }
};

/** Strips a trailing letter suffix added by {@link getFreeName}: `Kick 90 Right B` → `Kick 90 Right`. */
export const getBaseName = (name: string) => name.replace(/ [A-Z]+$/, '');
